/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { apiService } from './api.service';

export interface MentoringLessonItem {
	lessonid: string;

	lessontitle: string;

	sessionid: string | null;

	scheduledstart: string | null;

	actualstart: string | null;

	actualend: string | null;

	durationminutes: number;

	status: string;

	attendancestatus: string | null;

	courseid: string;

	coursetitle: string;

	coachid: string;

	coachname: string;
}

export interface LearnerMentoringHoursResponse {
	totalminutes: number;

	totalhours: number;

	thismonthminutes: number;

	thismonthhours: number;

	lessons: MentoringLessonItem[];
}

export const mentoringHoursService = {
	async getLearnerMentoringHours(
		courseid?: string
	): Promise<LearnerMentoringHoursResponse> {
		try {
			const query = courseid ? `?courseid=${courseid}` : '';

			const response =
				await apiService.get<LearnerMentoringHoursResponse>(
					`/user/dashboard/mentoring-hours${query}`
				);

			if (!response.success) {
				throw new Error(response.message);
			}

			return response.data;
		} catch (error: any) {
			console.error('Mentoring hours fetch error:', error);

			throw new Error(error.message || 'Failed to fetch mentoring hours');
		}
	},
};
